import React from 'react';
import {
  string,
  bool,
  node,
  shape,
} from 'prop-types';
import classNames from 'classnames';

import './DialogBox.scss';

const DialogBox = ({
  className,
  isShowArrow,
  fluid,
  innerRef,
  arrowRef,
  children,
  dayPicker,
}) => (
  <div
    className={classNames({
      'dialog-box': true,
      fluid,
      [className]: className && className.length > 0,
    })}
    ref={innerRef}
    data-selector-type="dialog-box"
  >
    {isShowArrow && (
      <div ref={arrowRef} className="arrow-wrapper">
        <span />
      </div>
    )}
    <div
      className={classNames(
        'box-wrapper',
        { 'day-picker': dayPicker }
      )}
    >
      {children}
    </div>
  </div>
);

DialogBox.propTypes = {
  className: string,
  isShowArrow: bool,
  fluid: bool,
  innerRef: shape({}),
  arrowRef: shape({}),
  children: node,
  dayPicker: bool,
};

DialogBox.defaultProps = {
  className: null,
  isShowArrow: false,
  fluid: false,
  innerRef: undefined,
  arrowRef: undefined,
  children: null,
  dayPicker: null,
};

export default DialogBox;
